import gql from 'graphql-tag';

export const DEAL_LISTING_ACTIVITY_FRAGMENT = gql`
  fragment DealListingEventActivityFields on DealEventActivityViewModel {
    id
    allDay
    subject
    priority
    eventType
    description
    activityStatus
    account {
      id
      name
    }

    participants {
      id
      fullName
      participationType
    }

    due {
      dueAt
      isOverdue
      secondsSinceDue
      secondsUntilDue
    }
  }
`;
